import { useEffect, useState } from 'react';
import DialogConfirmCancel from '../../../../../dialog/DialogConfirm';
import { useSelector } from 'react-redux';
import { FormControlLabel, Switch, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';

const DialogActionHiddeLevels = ({ show, onClose }) => {
  const userId = useSelector((state) => state?.session?.user?.userId || '');
  const { classId, curriculumId, ulId } = useParams();
  const key = `hideLevels_${userId}_${classId}_${curriculumId}_${ulId}`;

  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {});
  const lcs = useSelector((state) => state?.class?.unitOfLearning?.lcs || []);
  let levelsId = [];
  lcs.forEach((lc) => {
    const lvls = lc.granularSteps?.filter((step) => step.definition).map((step) => step.levelId);
    levelsId = [...levelsId, ...lvls];
  });

  levelsId = [...new Set(levelsId)];
  const levelsRender = currentCurriculum?.levels
    ?.filter((item) => levelsId.includes(item._id))
    .sort((a, b) => b.position - a.position);

  const [form, setForm] = useState({});

  const onConfirm = async (e) => {
    e.preventDefault();
    localStorage.setItem(key, JSON.stringify(form));
    window.dispatchEvent(
      new CustomEvent('hide-levels-updated', {
        detail: {
          key
        }
      })
    );
    onClose();
  };

  useEffect(() => {
    const data = localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : {};
    setForm(data);
  }, []);

  const onChange = (levelId, value) => {
    if (isEmpty(form)) {
      const data = {};
      levelsRender.forEach((item) => {
        data[item._id] = true;
      });
      data[levelId] = value;
      setForm(data);
      return;
    }
    setForm({ ...form, [levelId]: value });
  };

  return (
    <DialogConfirmCancel
      id={`dialog-action-hide-levels`}
      open={show}
      onCancel={onClose}
      onConfirm={onConfirm}
      title='Levels'
      maxWidth='xs'
    >
      {levelsRender.length > 0 ? (
        <div className='flex flex-col gap-2'>
          {levelsRender.map((item, i) => (
            <FormControlLabel
              key={item._id}
              value={item._id}
              name={item._id}
              className={['justify-between mr-0 ml-0 px-2 h-10', i % 2 === 0 ? 'bg-loading' : '']}
              control={
                <Switch
                  color='primary'
                  checked={isEmpty(form) ? true : form[item._id] || false}
                  onChange={(e) => onChange(item._id, e.target.checked)}
                  size='small'
                />
              }
              label={
                <Typography variant='inherit' color='primary' className='uppercase font-bold'>
                  {item.name}
                </Typography>
              }
              labelPlacement='start'
            />
          ))}
        </div>
      ) : (
        <p className='text-sm text-gray-500'>No levels to hide.</p>
      )}
    </DialogConfirmCancel>
  );
};

export default DialogActionHiddeLevels;
